import { createAction } from '@'
import { $modalVisible } from '../stores'

export default createAction('DestroyAllModals', () => {
    Object.values($modalVisible.getSubStore()).forEach(store => store.setState(s => (s === true ? undefined : s)))
})
